import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NbComponentStatus, NbIconConfig } from '@nebular/theme';

@Component({
  selector: 'wr-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BannerComponent {
  readonly icon = input.required<NbIconConfig>();
  readonly message = input.required<string>();
  readonly status = input.required<NbComponentStatus>();
}
